import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
  FC,
} from "react";
import { showProfile } from "../../services/Api";

interface User {
  uuid: string;
  name: string;
  lastName: string;
  code?: string;
  username: string;
  email: string;
  phone: string;
  identificationNumber: string;
  birthdate: string;
  ubigeo: string;
  address: string;
  role: string;
  gender: number;
  specialist?: string;
  headquarters?: string[];
  createdAt: string;
}

interface UserContextType {
  user: User | undefined;
  setUser: (user: User | undefined) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | undefined>(undefined);

  const handleGetUser = async () => {
    const storedUser = localStorage.getItem("token");
    if (storedUser) {
      const resp = await showProfile();
      setUser(resp.data);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("token");
    if (storedUser && !user) handleGetUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser debe usarse dentro de UserProvider");
  return ctx;
};
